import { combineEpics } from "redux-observable";
import history from "@ane/core/lib/CreateHistory";
import { experimentSearchEpics } from "./views/component/ExperimentSearch/ExperimentEpics.js";
import { flightSearchEpics } from "./views/component/FlightSearch/epics/FlightSearchEpic.js";
import { myActivitiesEpics } from "./views/component/MyActivities/MyActivitiesEpics.js";
import { searchEpics } from "./views/component/SearchEpics.js";
import "./views/component/FeatureSearchV3/search-context/index.js";
import "./views/component/FeatureSearchV4/search-context/index.js";
import { produceMyActivitiesRouteQueryStringSyncEpics } from "./views/component/MyActivities/MyActivitiesUserContext.js";
import { loadSubscriberDisplayNamesByEntitiesEpicReducer } from "./views/component/FeatureSearchV4/subscribers/epics.js";
import { experimentDetailsEpics } from "./views/component/FeatureSearchV4/feature-detail/ExperimentDetailsEpic.js";
import { featureDetailsEpics } from "./views/component/FeatureSearchV4/feature-detail/FeatureDetailsEpic.js";
import { activeProgressionsListPropsEpics } from "./views/component/FeatureSearchV4/active-progressions/ActiveProgressionsListPropsEpic.js";
import { rootEpic as rootEpic$1 } from "./views/component/FeatureSearchV3/search-context/epics.js";
import { rootEpic as rootEpic$2 } from "./views/component/FeatureSearchV4/search-context/epics.js";
const myActivitiesRouteQueryStringSyncEpics = produceMyActivitiesRouteQueryStringSyncEpics(history);
const rootEpic = combineEpics(
  experimentSearchEpics,
  flightSearchEpics,
  myActivitiesEpics,
  myActivitiesRouteQueryStringSyncEpics,
  searchEpics,
  rootEpic$1,
  rootEpic$2,
  loadSubscriberDisplayNamesByEntitiesEpicReducer.epic,
  experimentDetailsEpics,
  featureDetailsEpics,
  activeProgressionsListPropsEpics
);
export {
  rootEpic as default,
  rootEpic
};
//# sourceMappingURL=epics.js.map
